import React, { useEffect } from 'react';
import { useUser } from '../authentication';
import {
  connectEventStream,
  shutdownEventStream,
  subscribeToEventStreamLifecycle,
} from './services/eventStreamManager';

export const EventStreamProvider = ({ children }: { children: React.ReactNode }) => {
  const { user } = useUser();

  useEffect(() => subscribeToEventStreamLifecycle(), []);

  useEffect(() => {
    if (user?.userId) {
      connectEventStream(user.userId);
      return;
    }

    shutdownEventStream();
  }, [user?.userId]);

  return <>{children}</>;
};

EventStreamProvider.displayName = 'EventStreamProvider';
